import { api, buildQueryParams, URLs } from '@/libs/api'
import type {
  ApiResponse,
  CreateApiResult,
  CreateNotificationTriggerPayload,
  NotificationTrigger,
  NotificationTriggerListData,
  NotificationTriggerListParams,
  UpdateNotificationTriggerPayload,
} from '@/libs/interfaces'
import { notificationTriggersApiMock } from '@/libs/mocks/handlers/notificationTriggers'

const notificationTriggersApiReal = {
  create: async (
    payload: CreateNotificationTriggerPayload,
  ): Promise<CreateApiResult<NotificationTrigger>> => {
    return await api
      .post<ApiResponse<NotificationTrigger>>(
        URLs.NotificationTriggers.create(payload.orgID),
        payload,
      )
      .then((response) => ({
        data: response.data.data,
        status: response.status,
        message: response.message,
      }))
  },
  delete: async (payload: {
    orgID: string
    notificationTriggerID: string
  }): Promise<Partial<NotificationTrigger>> => {
    return await api
      .delete<ApiResponse<Partial<NotificationTrigger>>>(
        URLs.NotificationTriggers.byID(payload.orgID, payload.notificationTriggerID),
      )
      .then((response) => response.data?.data)
  },
  list: async (params: NotificationTriggerListParams): Promise<NotificationTrigger[]> => {
    const { orgID, ...queryParams } = params
    const query = buildQueryParams(queryParams)
    return await api
      .get<ApiResponse<NotificationTriggerListData>>(URLs.NotificationTriggers.list(orgID, query))
      .then((response) => response?.data?.data?.data || [])
  },
  update: async (payload: UpdateNotificationTriggerPayload): Promise<NotificationTrigger> => {
    const { orgID, notificationTriggerID, ...patchData } = payload
    return await api
      .patch<ApiResponse<NotificationTrigger>>(
        URLs.NotificationTriggers.byID(orgID, notificationTriggerID),
        patchData,
      )
      .then((response) => response.data?.data)
  },
}

export const notificationTriggersApi: typeof notificationTriggersApiReal = __IS_MOCK_MODE__
  ? notificationTriggersApiMock
  : notificationTriggersApiReal
